import { dirLtr } from './ltr.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Direction } from 'roosterjs-editor-types';
import { setDirection } from 'roosterjs-editor-api';

const ltr: RibbonButton = {
    key: 'ltr',
    title: () => loc(dirLtr),
    imageSrc: require('../svg/ltr.svg'),
    onExecute: plugin => setDirection(plugin.getEditor(), Direction.LeftToRight),
};

export default ltr;
